import Vue from "vue";
import VueI18n from "vue-i18n";
import zhLocal from "./lang/zh";
import enLocal from "./lang/en";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocal,
  },
  zh: {
    ...zhLocal,
  },
};

let defaultLang = localStorage.getItem("language") ? localStorage.getItem("language") : "zh";

const i18n = new VueI18n({
  locale: defaultLang,
  messages,
});

localStorage.setItem("language", defaultLang);

export default i18n;
